export default __webpack_public_path__ + "static/media/flower.565f0592.svg";